import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";

import type { ThemeType, } from "./dailyCheckInTypes"

export default function createThemeColumns(
  handleEdit: (record: ThemeType) => void,
): ColumnsType<ThemeType> {
  return [
    {
      title: 'Month',
      dataIndex: 'monthText',
      key: 'monthText',
    },
    {
      title: 'Theme slot',
      dataIndex: 'themeSlot',
      key: 'themeSlot',
    },
    {
      title: 'Date range',
      dataIndex: 'dateRange',
      key: 'dateRange',
    },
    {
      title: 'Theme name',
      dataIndex: 'themeName',
      key: 'themeName',
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record) => (
        <Button type="link" className="w-9 p-0" onClick={()=>handleEdit(record)}>
          Edit
        </Button>
      ),
    },
  ];
}